<template>
  <div id="bravarLocation" class="bravar-location">
    <h3 class="bravar-location__title title">Venha nos conhecer</h3>
    <div id="map"></div>
    <!-- <iframe
      id="map"
      src="https://www.google.com/maps/embed/v1/place?key=AIzaSyAiVfxsCbh9L3uObD1T4rgZqJ9Gtp_katc&q=Pra%C3%A7a+Pio+X,+78+-+Centro,+Rio+de+Janeiro+-+RJ&zoom=17"
      allowfullscreen
      title="Só de exemplo por enquanto para agilizar a visualização"
      frameborder="0"
    ></iframe>-->
  </div>
</template>
<script>
import markerIcon from "../../../public/favicon-2.png";
export default {
  name: "BravarLocation",
  data() {
    return {
      map: "",
      marker: "",
      lat: -22.9002205,
      long: -43.1779135,
      zoom: 17,
      maxZoom: 20,
      attribution:
        'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
      types: {
        streets: "mapbox.streets",
        satellite: "mapbox.satellite"
      },
      accessToken:
        "pk.eyJ1IjoiamVhbmJhcmJvc2E5IiwiYSI6ImNrMWd0d2J2NjBmMGEzY3MwcGgweThvM2IifQ.LNOyd93-8zg5DpPlirKvfQ"
    };
  },
  methods: {
    createMap: function() {
      this.map = L.map("map").setView([this.lat, this.long], this.zoom);
    },
    defineTileLayer: function() {
      L.tileLayer(
        "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}",
        {
          attribution: this.attribution,
          maxZoom: this.maxZoom,
          id: this.types.streets,
          accessToken: this.accessToken
        }
      ).addTo(this.map);
    },
    customMarkerIcon: function() {
      return L.icon({
        iconUrl: markerIcon,
        shadowUrl: "",
        iconSize: [40, 40],
        shadowSize: [50, 64],
        iconAnchor: [32, 32],
        shadowAnchor: [4, 62],
        popupAnchor: [-16, -30]
      });
    },
    addMapMarker: function() {
      const customIcon = this.customMarkerIcon();
      this.marker = L.marker([this.lat, this.long], { icon: customIcon }).addTo(
        this.map
      );
      this.bindMarkerPopup();
    },
    bindMarkerPopup: function() {
      const content = `
                        <div class="marker-popup">
                          <h1>Bravar Corretora</h1>
                          <address>
                            <strong>Endereço:</strong> Praça Pio X, 78, salas 912|914 - Centro, Rio de Janeiro / RJ
                          </address>
                          <p>
                            <strong>Horário de funcionamento:</strong> segunda à sexta das 9 às 18h
                          </p>
                          <p>
                            <phone><strong>Telefone fixo:</strong> <a href="tel:+55-21-22833149">(21) 2283-3149</a></phone>
                          </p>
                          <p>
                            <phone><strong>Whats App:</strong> <a href="tel:+55-21-22833115">(21) 2283-3115</a></phone>
                          </p>
                          <p>
                            <strong>e-mail: </strong><a href="mailto: contato@bravarcorretora.com.br">contato@bravarcorretora.com.br</a>
                          </p>
                        </div>
                      `;
      return this.marker.bindPopup(content);
    },
    openMapPopup: function(content) {
      const popup = L.popup()
        .setLatLng([this.lat, this.long])
        .setContent(content)
        .openOn(this.map);
    },
    handleMapClick: function() {
      this.bindMarkerPopup().openPopup();
    }
  },
  mounted() {
    this.createMap();
    this.defineTileLayer();
    this.addMapMarker();
    // this.map.on("click", this.handleMapClick);
  }
};
</script>
<style lang="scss">
.bravar-location {
  &__title {
    margin-bottom: $space__sm;
  }

  #map {
    width: 100vw;
    height: calc(100vw * 0.5625);

    @include breakpoint($tablet__min--sm) {
      max-height: 300px;
    }

    @include breakpoint($desk__min--sm) {
      width: calc(100vw - #{$space__md});
      /* height: calc((100vw * 0.5625) - 228px); - Altura 16/9 desconsiderando o header e barra de ferramentas do navegador*/
    }

    .leaflet-popup-close-button {
      width: 36px;
      height: 28px;
      font-size: 26px;
      line-height: 1;
    }

    .marker-popup {
      @include breakpoint($mobile__max--lg) {
        max-width: 200px;
      }

      a {
        color: $color__secondary;
      }
    }
  }
}
</style>